import * as GC from '@mescius/spread-sheets';

/**
 * マッピングやループの変更を行うカスタムコマンド
 **/
export const mappingAndLoopCommand = {
  canUndo: true,
  execute: (
    spread: GC.Spread.Sheets.Workbook,
    options: {
      cmd: string;
      propertyName: string;
      sheetIndex: number;
      rowIndex: number;
      columnIndex: number;
      applyFunc: () => void;
      revertFunc: () => void;
    },
    isUndo: boolean
  ) => {
    const Commands = GC.Spread.Sheets.Commands;
    if (isUndo) {
      // undo時に実行される処理
      options.revertFunc();

      Commands.undoTransaction(spread, options);

      return true;
    } else {
      // データモデル変更の記録を開始します
      Commands.startTransaction(spread, options);

      // コマンド呼び出し時に実行される処理
      options.applyFunc();

      //　データモデル変更の記録を終了します
      Commands.endTransaction(spread, options);

      return true;
    }
  },
};
